// The backend's `Organization_branch` enum values; each is also a
// `branchesOfIndustry` translation key.
export const ORGANIZATION_BRANCHES = [
  'accountancy',
  'advocatuur',
  'bank',
  'belangenbehartiging',
  'boekhandel',
  'effectenkredietinstelling',
  'franchiseorganisatie',
  'gemeente',
  'law_firm',
  'makelaar',
  'notariaat',
  'overheid',
  'overig',
  'pensioenfonds',
  'provincie',
  'rechterlijke_macht',
  'reclamebureau',
  'toezichthouder',
  'trustkantoor',
  'vastgoed',
  'verzekeraar',
  'waterschap',
  'woningbouwcorporatie',
  'bedrijfshuisvesting',
  'bedrijfsjuristen',
  'beheer_belegger_handel',
  'bouwonderneming',
  'consultancy',
  'dienstverl_inst_op_fin_ter',
  'energieleverancier',
  'onderwijs',
  'projectmanagement',
  'rentmeesters',
  'uitgeverij_op_juridisch_gebied',
  'universiteit',
  'vermbeh_effmak',
  'zorginstelling',
  'content_integrator',
] as const
